import React from 'react'
import {Modal} from 'react-bootstrap-v5'  

type Props = { 
  show: boolean,
  header: string, 
  text: string,
  handleClose: () => void,
  applyOnClick: () => void,
}

const ConfirmModal: React.FC<Props> = ({show,header,text,handleClose,applyOnClick}) => {
  
  return (
    <Modal
      className='modal fade'
      id='confirm_modal'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={show}
      dialogClassName='modal-sm'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>{header}</h5> 
        </div>
        <div className='modal-body'> 
          {text}
        </div>
        <div className='modal-footer'>
          <button type='button' className='btn btn-primary' onClick={handleClose}>
            Hayır
          </button>
          <button id='submit' type='button' className='btn btn-light-primary' onClick={applyOnClick}>
            Evet
          </button>
        </div>
      </div>
    </Modal>
  )
}

export {ConfirmModal}
